import { adminHttpClient } from '../../commons/adminHttpClient'
import { UserRoles } from '../../account/userRoles'

export interface SaveInternalUserRequest {
  id: string
  firstName: string
  lastName: string
  email: string
  apps: UserRoles[]
}

const saveInternalUser = (request: SaveInternalUserRequest): Promise<any> => {
  return adminHttpClient.post(`/csi/InternalUsers`, request)
}

export default saveInternalUser
